import { env } from '../env/env';
export const tpfSupplierApiConfig = {
    TPF_SUPPLIER_API_BASE_URL: env.getString('TPF_SUPPLIER_API_BASE_URL') || 'http://localhost:8081',
    TPF_SUPPLIER_API_ADMIN_BASE_URL: env.getString('TPF_SUPPLIER_API_BASE_URL')
        ? `${env.getString('TPF_SUPPLIER_API_BASE_URL')}/v2/tpf-api/admin`
        : 'http://localhost:8081/v2/tpf-api/admin',
};
//# sourceMappingURL=tpfSupplierApiConfig.js.map